export default
  process.env.REACT_APP_ENV === 'prod' ? 'prod' : 
  process.env.REACT_APP_ENV as any === 'qa' ? 'qa' :
  process.env.REACT_APP_ENV as any === 'uat' ? 'uat' :
  'dev';